module.exports = __webpack_public_path__ + "static/img/step-03.4ef43b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-03.png
// module id = DfG+
// module chunks = 1